import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import styled from "styled-components";
import Snackbar from "@mui/material/Snackbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchMinus, faSpinner } from "@fortawesome/free-solid-svg-icons";
import {
  getListOfInvestors,
  getListOfIncomingInvestors,
  advisorClientDetailsAction,
  resetClientSummaryData,
  advisorDetailsAction,
  resetAdvisorData,
  getIndividualAccountNotes,
  postAdvisorNote,
  resetAdvisorNote,
  individualAccountDetailsAction,
  getInviteClientAdvisorList,
  inviteClient,
  incomingClientDetailsAction,
  getCustodiansForFilter,
  getRIAsForFilter,
  getAdvisorsForFilter,
  applyFilterInMyClientsTable,
  applyFilterInIncomingClientsTable,
} from "../redux/actions";
import { useParams } from "react-router-dom";
import { SET_LOADING } from "../redux/action-types";
import LoadingBar from "../components/LoadingBar/LoadingBar";
import HeaderWithoutLogin from "../components/HeaderWithoutLogin";
import AdvisorIndividualClientSummaryModal from "../components/AdvisorIndividualClientSummaryModal/AdvisorIndividualClientSummaryModal";
import AdvisorDetailsModal from "../components/AdvisorDetailsModal/AdvisorDetailsModal";
import IncomingClientDetails from "../components/IncomingClientDetails/IncomingClientDetails";
import InviteClientModal from "../components/InviteClientModal/InviteClientModal";
import AdvisorSideBar from "../components/AdvisorSideBar/AdvisorSideBar";
import ClientListTable from "../components/ClientListTable/ClientListTable";
import FilterChips from "../components/FilterChips/FilterChips";
import IncomingClientListTable from "../components/IncomingClientListTable/IncomingClientListTable";
import AdvisorAnalyticsChartsContainer from "../components/AdvisorAnalyticsChartsContainer/AdvisorAnalyticsChartsContainer";
import IncomingAdvisorAnalyticsChartsContainer from "../components/IncomingAdvisorAnalyticsChartsContainer/IncomingAdvisorAnalyticsChartsContainer";
import { useState } from "react";

const BodyWrapper = styled.div`
  /* max-height: 100vh;
  overflow-y: hidden; */
  background-color: white;

  .filterChipsContainer {
    padding-left: 18px;
    display: flex;
    gap: 5px;
  }
  .tableControls {
    width: 100%;
    display: flex;
    margin-bottom: 10px;
    .start {
      padding: 0 20px;
      width: 70%;
      display: flex;
      gap: 20px;

      .tabName {
        font-weight: 700;
        font-size: 20px;
        color: #004576;
        cursor: pointer;
      }

      .active {
        border-bottom: 3px solid #48c8f4;
      }
    }

    .end {
      width: 30%;
      padding: 0 40px;
      display: flex;
      gap: 10px;
      justify-content: end;

      .searchContainer {
        padding: 0px 10px;
        display: flex;
        gap: 20px;
        font-size: 20px;
        border-bottom: 1px solid #004576;
        .searchInput {
          width: 180px;
          background-color: white;
        }
        .rotate {
          animation: rotating 2s linear infinite;
        }

        @keyframes rotating {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      }

      .button {
        border-radius: 4px;
        background: #004576;
        border: none;
        color: white;
        padding: 4px 26px;
        cursor: pointer;
      }
    }
  }

  .scrollMessage {
    position: fixed;
    bottom: 0;
    padding-bottom: 10px;
    width: 100%;
    text-align: center;
    padding-top: 10px;
    background-color: white;
  }
`;

const AdvisorPortalAccountManagement = () => {
  const {
    listOfAdvisors,
    listOfIncomingAdvisors,
    advisorClientDetails,
    advisorDetails,
    setAdvisorNote,
    individualAccountNotes,
    loading,
    individualAccountDetails,
    InviteClientAdvisorList,
    filterDataOnClientTable,
    filterDataOnIncomingClientTable,
    incomingClientDetails,
  } = useSelector((state) => state.user);
  const { defaultTab } = useParams();
  const [isFirstExecution, setIsFirstExecution] = useState(true);
  const [isMyClientActive, setIsMyClientActive] = useState(
    defaultTab === "retail-pipline" ? false : true
  );
  const [pageNumber, setPageNumber] = useState(1);
  const [incomingPageNumber, setIncomingPageNumber] = useState(1);
  const [isClientListLoading, setIsClientListLoading] = useState(false);
  const [isIncomingClientListLoading, setIsIncomingClientListLoading] =
    useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [listOfAdvisorsState, setListOfAdvisorsState] = useState([]);
  const [listOfIncomingAdvisorsState, setListOfIncomingAdvisorsState] =
    useState([]);
  const [sortingItems, setSortingItems] = useState([
    {
      name: "ClientName",
      isAscending: true,
    },
  ]);
  const [sortingIncomingItems, setSortingIncomingItems] = useState([
    {
      name: "DateCreated",
      isAscending: true,
    },
  ]);
  const [
    isAdvisorIndividualClientSummaryModalShow,
    setIsAdvisorIndividualClientSummaryModalShow,
  ] = useState(false);
  const [isAdvisorDetailsModalShow, setIsAdvisorDetailsModalShow] =
    useState(false);
  const [isIncomingClientModalShow, setIsIncomingClientModalShow] =
    useState(false);
  const [searchText, setSearchText] = useState(null);
  const [activeAccountId, setActiveAccountId] = useState("");
  const [inviteClientError, setInviteClientError] = useState("");
  const [isInviteClientModalShow, setIsInviteClientModalShow] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);
  const [isSnackBarVisible, setisSnackBarVisible] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [firstIncomingLoading, setFirstIncomingLoading] = useState(true);
  const dispatch = useDispatch();

  const handleScrollOnTable = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop ===
        e.target.clientHeight + 1 ||
      Math.ceil(e.target.scrollHeight - e.target.scrollTop) ===
        e.target.clientHeight ||
      Math.round(e.target.scrollHeight - e.target.scrollTop) ===
        e.target.clientHeight + 1 ||
      Math.round(e.target.scrollHeight - e.target.scrollTop) ===
        e.target.clientHeight;

    if (bottom && !isClientListLoading) {
      dispatch(
        getListOfInvestors(
          pageNumber,
          15,
          searchText,
          sortingItems,
          filterDataOnClientTable
        )
      );
      setIsClientListLoading(true);
    }
  };

  const handleScrollOnIncomingTable = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop ===
        e.target.clientHeight + 1 ||
      Math.ceil(e.target.scrollHeight - e.target.scrollTop) ===
        e.target.clientHeight ||
      Math.round(e.target.scrollHeight - e.target.scrollTop) ===
        e.target.clientHeight + 1 ||
      Math.round(e.target.scrollHeight - e.target.scrollTop) ===
        e.target.clientHeight;

    if (bottom && !isIncomingClientListLoading) {
      dispatch(
        getListOfIncomingInvestors(
          incomingPageNumber,
          15,
          searchText,
          sortingIncomingItems,
          filterDataOnIncomingClientTable
        )
      );
      setIsIncomingClientListLoading(true);
    }
  };

  useEffect(() => {
    dispatch({ type: SET_LOADING, payload: false });
    setIsLoaded(false);
  }, [advisorDetails, incomingClientDetails]);

  useEffect(() => {
    if (!isFirstExecution) {
      setPageNumber(1);
      setListOfAdvisorsState([]);
      dispatch({ type: SET_LOADING, payload: true });
      setIsLoaded(false);
      dispatch(
        getListOfInvestors(
          1,
          15,
          searchText,
          sortingItems,
          filterDataOnClientTable
        )
      );
      setIsClientListLoading(true);
    }
  }, [filterDataOnClientTable]);

  useEffect(() => {
    if (!isFirstExecution) {
      setIncomingPageNumber(1);
      setListOfIncomingAdvisorsState([]);
      dispatch(
        getListOfIncomingInvestors(
          1,
          15,
          searchText,
          sortingIncomingItems,
          filterDataOnIncomingClientTable
        )
      );
      setIsIncomingClientListLoading(true);
    }
  }, [filterDataOnIncomingClientTable]);

  useEffect(() => {
    if (advisorClientDetails?.hasOwnProperty("userId")) {
      dispatch({ type: SET_LOADING, payload: false });
      setIsLoaded(false);
      dispatch(individualAccountDetailsAction(advisorClientDetails?.userId));
    }
  }, [advisorClientDetails]);

  useEffect(() => {
    dispatch({ type: SET_LOADING, payload: false });
    setIsLoaded(false);
    setIsClientListLoading(false);
    setIsSearchLoading(false);
    setIsClientListLoading(false);
    setListOfAdvisorsState([
      ...listOfAdvisorsState,
      ...(listOfAdvisors?.accounts || []),
    ]);
    if (listOfAdvisors?.accounts.length) setPageNumber(pageNumber + 1);
  }, [listOfAdvisors?.accounts]);

  useEffect(() => {
    if (!firstIncomingLoading) {
      dispatch({ type: SET_LOADING, payload: false });
      setIsLoaded(false);
    }
    if (listOfIncomingAdvisors?.accounts) {
      setFirstIncomingLoading(false);
    }
    setIsClientListLoading(false);
    setIsSearchLoading(false);
    setIsIncomingClientListLoading(false);
    setListOfIncomingAdvisorsState([
      ...listOfIncomingAdvisorsState,
      ...(listOfIncomingAdvisors?.accounts || []),
    ]);
    if (listOfIncomingAdvisors?.accounts?.length)
      setIncomingPageNumber(incomingPageNumber + 1);
  }, [listOfIncomingAdvisors?.accounts]);

  useEffect(() => {
    if (!listOfAdvisors?.accounts || listOfAdvisors?.accounts?.length <= 0) {
      dispatch(getCustodiansForFilter());
      dispatch(getRIAsForFilter());
      dispatch(getAdvisorsForFilter());
      dispatch({ type: SET_LOADING, payload: true });
      setIsLoaded(false);
      dispatch(
        getListOfInvestors(
          pageNumber,
          15,
          searchText,
          sortingItems,
          filterDataOnClientTable
        )
      );
      setIsClientListLoading(true);
      setIsFirstExecution(false);
    }
    if (
      !listOfIncomingAdvisors?.accounts ||
      listOfIncomingAdvisors?.accounts.length <= 0
    ) {
      dispatch(
        getListOfIncomingInvestors(
          incomingPageNumber,
          15,
          searchText,
          sortingIncomingItems,
          filterDataOnIncomingClientTable
        )
      );
      setIsIncomingClientListLoading(true);
    }
  }, []);

  useEffect(() => {
    if (setAdvisorNote?.hasOwnProperty("noteId")) {
      dispatch(getIndividualAccountNotes(activeAccountId));
    }
  }, [setAdvisorNote]);

  const handleClientNameClick = (clientId, externalId) => {
    dispatch({ type: SET_LOADING, payload: true });
    setIsLoaded(false);
    dispatch(advisorClientDetailsAction(clientId));
    dispatch(getIndividualAccountNotes(clientId));
    setActiveAccountId(clientId);
    setIsAdvisorIndividualClientSummaryModalShow(true);
  };

  const handleIncomingClientNameClick = (goalId) => {
    dispatch({ type: SET_LOADING, payload: true });
    setIsLoaded(false);
    dispatch(incomingClientDetailsAction(goalId));
    setIsIncomingClientModalShow(true);
  };

  const handleAdvisorNameClick = (advisorId) => {
    dispatch({ type: SET_LOADING, payload: true });
    setIsLoaded(false);
    dispatch(advisorDetailsAction(advisorId));
    setIsAdvisorDetailsModalShow(true);
  };

  const handleAdvisorIndividualClientSummaryModalOnClose = () => {
    setIsAdvisorIndividualClientSummaryModalShow(false);
    //dispatch(resetClientSummaryData());
    dispatch(resetAdvisorNote());
  };

  const handleAdvisorDetailsModalOnClose = () => {
    setIsAdvisorDetailsModalShow(false);
    //dispatch(resetAdvisorData());
  };

  const handleIncomingClientDetailsModalOnClose = () => {
    setIsIncomingClientModalShow(false);
    //dispatch(resetAdvisorData());
  };

  const handleNotePost = (text) => {
    dispatch(postAdvisorNote(activeAccountId, text));
  };

  const handleInviteClientClick = () => {
    setIsInviteClientModalShow(true);
    dispatch(getInviteClientAdvisorList());
  };

  const handleInviteClientModalClose = () => {
    setIsInviteClientModalShow(false);
  };

  const handleInviteClient = (payload) => {
    dispatch({ type: SET_LOADING, payload: true });
    setIsLoaded(false);
    dispatch(inviteClient(payload)).then((data) => {
      if (data?.status === 200) {
        setIsInviteClientModalShow(false);
        setisSnackBarVisible(true);
        setSnackBarMessage("Client invited");
      } else {
        setInviteClientError("An account with the given email already exists");
      }
      dispatch({ type: SET_LOADING, payload: false });
      setIsLoaded(false);
    });
  };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleSearchBoxClear = () => {
    setListOfAdvisorsState([]);
    setSearchText("");
    setPageNumber(1);
    setIsClientListLoading(true);
    //dispatch(getListOfInvestors(1, 15, "", sortingItems));
  };

  useEffect(() => {
    if (searchText == null) return;
    if (searchText == "") {
      // if (isMyClientActive) {
      setPageNumber(1);
      setListOfAdvisorsState([]);
      dispatch(
        getListOfInvestors(1, 15, "", sortingItems, filterDataOnClientTable)
      );
      // } else {
      setIncomingPageNumber(1);
      setListOfIncomingAdvisorsState([]);
      dispatch(
        getListOfIncomingInvestors(
          1,
          15,
          searchText,
          sortingIncomingItems,
          filterDataOnIncomingClientTable
        )
      );
      // }
      return;
    }
    const timeoutId = setTimeout(() => {
      if (isMyClientActive) {
        setListOfAdvisorsState([]);
        setPageNumber(1);
        dispatch(
          getListOfInvestors(
            1,
            15,
            searchText,
            sortingItems,
            filterDataOnClientTable
          )
        );
        setIsClientListLoading(true);
        setIsSearchLoading(true);
      } else {
        setListOfIncomingAdvisorsState([]);
        setIncomingPageNumber(1);
        dispatch(
          getListOfIncomingInvestors(
            1,
            15,
            searchText,
            sortingIncomingItems,
            filterDataOnIncomingClientTable
          )
        );
        setIsIncomingClientListLoading(true);
        setIsSearchLoading(true);
      }
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchText]);

  const handleFilterApplied = () => {
    dispatch({ type: SET_LOADING, payload: true });
    setIsLoaded(false);
  };

  const handleSortClientTable = (columnName, order) => {
    setListOfAdvisorsState([]);
    setPageNumber(1);
    let tempSortingItems = sortingItems;
    if (order == 0) {
      setSortingItems(
        tempSortingItems.filter((data) => data.name !== columnName)
      );
      tempSortingItems = tempSortingItems.filter(
        (data) => data.name !== columnName
      );
    } else if (order == 1) {
      let flag = 0;
      tempSortingItems.forEach((data) => {
        if (data.name === columnName) {
          data.isAscending = true;
          flag = 1;
        }
      });
      if (flag == 0) {
        tempSortingItems.push({ name: columnName, isAscending: true });
      }
    } else if (order == 2) {
      let flag = 0;
      tempSortingItems.forEach((data) => {
        if (data.name === columnName) {
          data.isAscending = false;
          flag = 1;
        }
      });
      if (flag == 0) {
        tempSortingItems.push({ name: columnName, isAscending: false });
      }
    }
    dispatch({ type: SET_LOADING, payload: true });
    setIsLoaded(false);
    dispatch(
      getListOfInvestors(
        1,
        15,
        searchText,
        tempSortingItems,
        filterDataOnClientTable
      )
    );
    setIsClientListLoading(true);
  };

  const handleFilterAppliedOnIncomingList = () => {
    dispatch({ type: SET_LOADING, payload: true });
    setIsLoaded(false);
  };

  const handleSortIncomingClientTable = (columnName, order) => {
    setListOfIncomingAdvisorsState([]);
    setIncomingPageNumber(1);
    let tempSortingItems = sortingIncomingItems;
    if (order == 0) {
      setSortingIncomingItems(
        tempSortingItems.filter((data) => data.name !== columnName)
      );
      tempSortingItems = tempSortingItems.filter(
        (data) => data.name !== columnName
      );
    } else if (order == 1) {
      let flag = 0;
      tempSortingItems.forEach((data) => {
        if (data.name === columnName) {
          data.isAscending = true;
          flag = 1;
        }
      });
      if (flag == 0) {
        tempSortingItems.push({ name: columnName, isAscending: true });
      }
    } else if (order == 2) {
      let flag = 0;
      tempSortingItems.forEach((data) => {
        if (data.name === columnName) {
          data.isAscending = false;
          flag = 1;
        }
      });
      if (flag == 0) {
        tempSortingItems.push({ name: columnName, isAscending: false });
      }
    }
    dispatch({ type: SET_LOADING, payload: true });
    setIsLoaded(false);
    dispatch(
      getListOfIncomingInvestors(
        1,
        15,
        searchText,
        tempSortingItems,
        filterDataOnIncomingClientTable
      )
    );
    setIsIncomingClientListLoading(true);
  };

  const handleMyClientTabHeader = () => {
    setIsMyClientActive(true);
    if (searchText !== null && searchText !== "") setSearchText("");
  };

  const handleIncomingClientTabHeader = () => {
    setIsMyClientActive(false);
    if (searchText !== null && searchText !== "") setSearchText("");
  };

  const handleFilterChipsCrossClick = (filterName) => {
    let tempFilter = [...filterDataOnClientTable];
    tempFilter = tempFilter.filter((data) => data.columnName !== filterName);
    dispatch(applyFilterInMyClientsTable(tempFilter));
  };

  const handleFilterChipsCrossClickForRetail = (filterName) => {
    let tempFilter = [...filterDataOnIncomingClientTable];
    tempFilter = tempFilter.filter((data) => data.columnName !== filterName);
    dispatch(applyFilterInIncomingClientsTable(tempFilter));
  };

  return (
    <BodyWrapper>
      {(!isLoaded || loading) && (
        <LoadingBar isLoading={loading} setIsLoaded={setIsLoaded} />
      )}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={isSnackBarVisible}
        autoHideDuration={3000}
        message={snackBarMessage}
        onClose={() => {
          setisSnackBarVisible(false);
        }}
      />
      {isInviteClientModalShow && (
        <InviteClientModal
          advisorList={InviteClientAdvisorList}
          isInviteClientModalShow={isInviteClientModalShow}
          inviteClientModalOnClose={handleInviteClientModalClose}
          inviteClient={handleInviteClient}
          inviteClientError={inviteClientError}
        />
      )}
      <AdvisorIndividualClientSummaryModal
        isAdvisorIndividualClientSummaryModalShow={
          isAdvisorIndividualClientSummaryModalShow
        }
        advisorIndividualClientSummaryModalOnClose={
          handleAdvisorIndividualClientSummaryModalOnClose
        }
        data={advisorClientDetails}
        postNote={handleNotePost}
        individualAccountNotes={individualAccountNotes}
        individualAccountDetails={individualAccountDetails}
        setAdvisorNote={setAdvisorNote}
      />
      <AdvisorDetailsModal
        isAdvisorDetailsModalShow={isAdvisorDetailsModalShow}
        advisorDetailsModalOnClose={handleAdvisorDetailsModalOnClose}
        data={advisorDetails}
      />
      <IncomingClientDetails
        isIncomingClientDetailsModalShow={isIncomingClientModalShow}
        incomingClientDetailsModalOnClose={
          handleIncomingClientDetailsModalOnClose
        }
        data={incomingClientDetails}
      />

      <AdvisorSideBar activeSection={2} />
      <div style={{ marginLeft: "80px" }}>
        <HeaderWithoutLogin
          isLogoClickFromAdvisorPortal={true}
          isHelpButtonVisible={false}
        />
        {isMyClientActive ? (
          <AdvisorAnalyticsChartsContainer
            assetUnderManagment={listOfAdvisors?.assetUnderManagment}
            clientTypeReport={listOfAdvisors?.clientTypeReport}
          />
        ) : (
          <IncomingAdvisorAnalyticsChartsContainer
            clientTypeReport={listOfIncomingAdvisors?.clientTypeReport}
            openInvitations={listOfIncomingAdvisors?.openInvitations}
          />
        )}
        <div className="tableControls">
          <div className="start">
            <div
              className={`tabName ${isMyClientActive && "active"}`}
              onClick={handleMyClientTabHeader}
            >
              My Clients
            </div>
            <div
              className={`tabName ${!isMyClientActive && "active"}`}
              onClick={handleIncomingClientTabHeader}
            >
              Retail Pipeline
            </div>
          </div>
          <div className="end">
            <div className="searchContainer">
              <input
                placeholder="Search by Name or Account"
                className="searchInput"
                value={searchText}
                disabled={isSearchLoading ? true : false}
                onChange={handleSearchChange}
              />
              {searchText == "" ? (
                <span className={`${isSearchLoading ? "rotate" : ""}`}>
                  <FontAwesomeIcon
                    icon={isSearchLoading ? faSpinner : faSearchMinus}
                    style={{ color: "#004576" }}
                  />
                </span>
              ) : !isSearchLoading ? (
                <span
                  style={{
                    fontSize: "16px",
                    color: "#004576",
                    fontWeight: "800",
                    cursor: "pointer",
                  }}
                  onClick={handleSearchBoxClear}
                >
                  X
                </span>
              ) : (
                <span className="rotate">
                  <FontAwesomeIcon
                    icon={faSpinner}
                    style={{ color: "#004576" }}
                  />
                </span>
              )}
            </div>
            <button className="button" onClick={handleInviteClientClick}>
              Invite Client
            </button>
          </div>
        </div>
        {isMyClientActive
          ? filterDataOnClientTable.length > 0 && (
              <div className="filterChipsContainer">
                {filterDataOnClientTable?.map((data) => (
                  <FilterChips
                    filterName={data?.columnName}
                    value={data?.valuesText || data.values}
                    lowerLimit={
                      data?.LowerLimitByText || data?.lowerLimit || null
                    }
                    upperLimit={
                      data?.UpperLimitByText || data?.upperLimit || null
                    }
                    onCrossClick={handleFilterChipsCrossClick}
                  />
                ))}
              </div>
            )
          : filterDataOnIncomingClientTable.length > 0 && (
              <div className="filterChipsContainer">
                {filterDataOnIncomingClientTable?.map((data) => (
                  <FilterChips
                    filterName={data?.columnName}
                    value={data?.valuesText || data.values}
                    lowerLimit={
                      data?.LowerLimitByText || data?.lowerLimit || null
                    }
                    upperLimit={
                      data?.UpperLimitByText || data?.upperLimit || null
                    }
                    onCrossClick={handleFilterChipsCrossClickForRetail}
                  />
                ))}
              </div>
            )}
        {isMyClientActive ? (
          <ClientListTable
            listOfAdvisors={listOfAdvisorsState}
            handleScrollOnTable={handleScrollOnTable}
            handleClientNameClick={handleClientNameClick}
            handleAdvisorNameClick={handleAdvisorNameClick}
            sortClientTable={handleSortClientTable}
            filterApplied={handleFilterApplied}
          />
        ) : (
          <IncomingClientListTable
            listOfAdvisors={listOfIncomingAdvisorsState}
            handleScrollOnTable={handleScrollOnIncomingTable}
            handleAdvisorNameClick={handleAdvisorNameClick}
            handleClientNameClick={handleIncomingClientNameClick}
            sortIncomingClientTable={handleSortIncomingClientTable}
            filterApplied={handleFilterAppliedOnIncomingList}
          />
        )}
        {isMyClientActive ? (
          <div className="scrollMessage">
            {isClientListLoading
              ? "Loading..."
              : listOfAdvisors?.accounts?.length >= 15
              ? "Scroll to load more"
              : listOfAdvisorsState.length == 0
              ? "No data found"
              : ""}
          </div>
        ) : (
          <div className="scrollMessage">
            {isIncomingClientListLoading
              ? "Loading..."
              : listOfIncomingAdvisors?.accounts?.length >= 15
              ? "Scroll to load more"
              : listOfIncomingAdvisorsState.length == 0
              ? "No data found"
              : ""}
          </div>
        )}
      </div>
    </BodyWrapper>
  );
};

export default AdvisorPortalAccountManagement;
